
import React, { useEffect, useState } from 'react';
import { RawMaterialPurchaseListDTO } from "../../models/RawMaterials/RawMaterial-model";
import RawMaterialPurchaseForm from './RawMaterialspurchase';
import { t } from 'i18next';
import RawMaterialsSearch from './RawMaterial-Search';
import RawMaterialsDatatable from './RawMaterialDatatable';
import RawMaterialService from '../../services/RawMaterials/RawMaterialService';
import { rawMaterialExport } from './RawmaterialList-Export';
import { Button } from 'primereact/button';
const RawMaterialsPage: React.FC = () => {
  const [materials, setMaterials] = useState<RawMaterialPurchaseListDTO[]>([]);
  const [qcStatuses, setQcStatuses] = useState<any[]>([]); 
  const [filters, setFilters] = useState({
    materialId: null,
     rmCategoryId: null, 
    activeOnly: true,
    sortColumn: 'createdDate',
    sortDirection: 'desc',
     keyword: "",
      invoiceNumber: null ,
  startDate: undefined as string | Date | undefined,
  endDate: undefined as string | Date | undefined
  });
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

    const handleSearch = (searchFilters: any) => {
      setFilters(searchFilters);
      setPageNumber(1);
    };

  const fetchMaterials = async () => {
    try {
      const payload = {  
        pageNumber,
        pageSize,
        ...filters
      };
      const response = await RawMaterialService.getRawMaterialPurchases(payload);
      console.log("Fetched materials:", response.rawMaterialPurchases);
     setMaterials(response.rawMaterialPurchases || []);
     setTotalRecords(response.totalRecords || 0);
     setQcStatuses(response.qcStatuses ?? []);
    } catch (error) {
      console.error("Error loading materials:", error);
      setMaterials([]);
      setTotalRecords(0);
      setQcStatuses([]);
    }
  };


const handleSortChange = (field: string, order: 1 | -1) => {
  const columnMapping: Record<string, string> = {
    invoiceId: "invoiceNumber",
    createdbyName: "createdByName",
    rawMaterialName: "rawMaterialName",
    categoryName: "categoryName",
    vendorName: "vendorName",
    purchaseDate: "purchaseDate",
    quantityWithUnit: "quantity",   // backend stores only quantity
    basicAmount: "basicAmount",
    taxAmount: "taxAmount",
    totalAmount: "totalAmount",
    createdDate: "createdDate"
  };

  const mappedField = columnMapping[field] || field;

  const updatedFilters = {
    ...filters,
    sortColumn: mappedField,
    sortDirection: order === 1 ? "asc" : "desc"
  };

  setFilters(updatedFilters);
};
const handleExport = async () => {
  try {
    // Use the exact same filters used for fetching data
    const payload = {
      pageNumber: 1,            // Optional: not required for export, but can include
      pageSize: totalRecords,   // Optional: export all
      materialId: filters.materialId,
      rmCategoryId: filters.rmCategoryId,
      startDate: filters.startDate,
      endDate: filters.endDate,
      activeOnly: filters.activeOnly,
      sortColumn: filters.sortColumn,
      sortDirection: filters.sortDirection,
      keyword: filters.keyword,
      invoiceNumber: filters.invoiceNumber,
    };

    // Call export function with identical filter payload
    await rawMaterialExport(payload);
  } catch (error) {
    console.error("Error exporting raw materials:", error);
  }
};


  const handleReset = () => {
    setFilters({
      materialId: null,
      //supplierId: null,
      activeOnly: true,
        rmCategoryId: null, 
      sortColumn: 'createdDate',
      sortDirection: 'desc',
       keyword: "",
        invoiceNumber: null ,
         startDate: undefined,   // ✅ Added
  endDate: undefined  
    });
    setPageNumber(1);
  };

  const handlePageChange = (event: any) => {
    setPageNumber(event.page + 1);
    setPageSize(event.rows);
  };

  const handleUpdate = (material: RawMaterialPurchaseListDTO) => {
    fetchMaterials();
  };

  useEffect(() => {
    fetchMaterials();
  }, [pageNumber, pageSize, filters]);

  return (
    <div className="p-3">
      <div className="col-12">
        <div className="flex align-items-center justify-content-between flex-wrap gap-2 w-full card-container mb-0">
          <h4 className="ml-1 mb-0">{t("Quality Check")}</h4>
          <Button
            className="text-black border-round mr-2 mb-1"
            onClick={handleExport}
            icon="pi pi-file-export mr-1"
            text
            raised
            tooltip="Export to Excel"
            tooltipOptions={{ position: 'top' }}
            style={{ width: "auto", marginLeft: "10px" }}
          >
            Export All Raw Materials
          </Button>
        </div>
      </div>
      <RawMaterialsSearch
        onSearch={handleSearch}
        onReset={handleReset}
        totalRecords={totalRecords}
      />
      <RawMaterialsDatatable
        data={materials}
        pageNumber={pageNumber}
        pageSize={pageSize}
        totalRecords={totalRecords}
        onPageChange={handlePageChange}
        onSortChange={handleSortChange}
        onUpdate={handleUpdate}
        qcStatuses={qcStatuses}
      />
    </div>
  );
};

export default RawMaterialsPage;